
import React from 'react'
import { mdx } from '@mdx-js/react'
export const readingTime = {"text":"1 min read","minutes":0.675,"time":40500,"words":135}
/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <div className="column">
Ces travaux de recherche ont été réalisés dans le cadre de la Chaire «Good In Tech : repenser l’innovation et les technologies comme moteurs d’un monde meilleur pour et par l’humain » placée sous l’égide de la Fondation du Risque en partenariat avec l’Institut Mines-Télécom et Sciences Po.
      <div className="logos-container">
  <a target="blank" rel="noopener" href="https://medialab.sciencespo.fr/">
    <img src="https://medialab.sciencespo.fr/img/cover-twitter.png" alt="logo médialab" />
  </a>
  <a target="blank" rel="noopener" href="https://www.goodintech.org/?lng=fr">
    <img src="https://www.goodintech.org/uploads/1580497528960-Logo.png" alt="logo good in tech" />
  </a>
  <a target="blank" rel="noopener" href="https://www.imt.fr/">
    <img src="https://upload.wikimedia.org/wikipedia/commons/b/b0/IMT_logo_2017.png" alt="logo institut mines télécom" />
  </a>
      </div>
    </div>
    <div className="column">
      <p>{`Auteurs `}<strong parentName="p">{`Maxime Crépel, Dominique Cardon`}</strong></p>
      <p>{`Traitement de données `}<strong parentName="p">{`Yannis Bouachera, Salomé Do, Jean-Philippe Cointet, Jean-Marie John-Mathews`}</strong></p>
      <p>{`Design d’information `}<strong parentName="p">{`Robin De Mourat, Donato Ricci`}</strong></p>
      <p>{`Les contenus de ce site sont partagés sous la license `}<a parentName="p" {...{
          "href": "https://creativecommons.org/licenses/by-nc-sa/4.0/"
        }}>{`Creative Commons Attribution-NonCommercial-ShareAlike 4.0 International (CC BY-NC-SA 4.0) `}</a></p>
      <p><strong parentName="p"><a parentName="strong" {...{
            "href": "https://github.com/medialab/carnet-algopresse"
          }}>{`Code source de ce site`}</a></strong></p>
    </div>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
export const tableOfContents = (components={}) => [
  
]

export const frontMatter = {}

